<template>
  <div id="sponsors-page" v-if="this.categories">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button
              icon="fas fa-plus"
              type="primary"
              size="small"
              round
              @click="
                updateFormCategory = null;
                addCategoryModal = true;
              "
              >{{ $t("contentManagement.sponsors.addCategory") }}</el-button
            >
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.sponsors.title") }}</h5>
              <span v-if="$store.state.sponsors.items.length > 0 || $store.state.sponsors.categories.length > 0">
                <template v-if="$i18n.locale == 'tr'">
                  Toplam {{ $store.state.sponsors.categories.length > 0 ? $store.state.sponsors.categories.length + " kategoride" : "" }}
                  {{ $store.state.sponsors.categories.length > 0 ? $store.state.sponsors.items.length + " adet sponsor bulunmaktadır." : "" }}
                </template>
                <template v-else>
                  There are {{ $store.state.sponsors.categories.length > 0 ? $store.state.sponsors.items.length + " sponsors" : "" }}
                  {{ $store.state.sponsors.categories.length > 0 ? " in a total of " + $store.state.sponsors.categories.length + " categories." : "" }}
                </template>
              </span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe('https://holacon.com/product-guide/detail/how-to-add-sponsor-on-event-planner-console')" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click.stop="getData" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" :date="currDate" v-if="categories.length > 0">
            <draggable id="draggable" :list="categories" class="list-group-o" handle=".el-icon-s-grid" group="b" tag="div" v-bind="dragOptions" @start="drag = true" @end="drag = false">
              <div class="sponsor-category-wrapper" v-for="(item, index) in categories" :key="item.id">
                <div class="sponsor-category" :class="item.isActive ? '' : 'passive'">
                  <div class="category-title">{{ item.title }}</div>
                  <div class="sponsor-category-slider">
                    <el-slider style="margin: 0" :min="5" :max="50" v-model="categories[index].logoScale" @change="saveSorting"></el-slider>
                  </div>
                  <div class="sponsor-category-drag">
                    <i class="el-icon-s-grid"></i>
                  </div>
                  <div class="sponsor-category-actions">
                    <el-button-group>
                      <el-tooltip class="item" effect="dark" :content="$t('event.buttons.editCat')" placement="top-end">
                        <el-button
                          size="mini"
                          round
                          type="default"
                          icon="fas fa-pen"
                          @click="
                            updateFormCategory = item.id;
                            addCategoryModal = true;
                          "
                        ></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" :content="$t('event.buttons.addSponsor')" placement="top-end">
                        <el-button
                          size="mini"
                          round
                          type="primary"
                          icon="fas fa-plus"
                          @click="
                            currentCategory = item.id;
                            addModal = true;
                            updateForm = null;
                          "
                        ></el-button>
                      </el-tooltip>
                    </el-button-group>
                  </div>
                </div>

                <!-- <div class="add-sponsor" v-if="item.sponsors.length == 0">
                  <div class="add-sponsor-container" @click="currentCategory = item.id; addModal = true; updateForm = null;">
                    <div class="add-sponsor-wrapper" :style="{ width: item.logoScale * 5 + 'px', height: item.logoScale * 5 + 'px', }">
                      <span v-if="item.logoScale >= 10">Yeni sponsor ekleyin</span>
                      <span v-else>+</span>
                    </div>
                  </div>
                </div> -->

                <draggable id="draggable" :list="categories[index].sponsors" class="list-group-o" group="a" tag="div" v-bind="dragOptions" @start="drag = true" @end="drag = false">
                  <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div v-for="element in item.sponsors" :key="element.id" class="sponsor-item" :class="element.isActive ? '' : 'img-passive-item'">
                      <el-tooltip class="item" effect="dark" :content="element.title" placement="top-start">
                        <el-image
                          class="sponsor-item-img"
                          @click="
                            updateForm = element.id;
                            addModal = true;
                            currentCategory = item.id;
                          "
                          :style="{ width: item.logoScale * 5 + 'px', height: item.logoScale * 5 + 'px' }"
                          :src="$imageus + element.image + '?width=300px&height=300px&mode=contain&background=FFFFFF'"
                          :fit="'contain'"
                          :class="element.isActive ? '' : 'img-passive'"
                        ></el-image>
                      </el-tooltip>
                    </div>
                  </transition-group>
                </draggable>
              </div>
            </draggable>

            <div
              class="add-category"
              @click="
                updateFormCategory = null;
                addCategoryModal = true;
              "
            >
              <span><i class="fas fa-plus"></i>{{ this.$t("event.components.sponsors.add") }}</span>
            </div>
          </div>
          <div v-else>
            <HolaconLottieNoData
              class="w-100"
              key="create-loading"
              :source="'holacon-sponsors-lottie'"
              :title="$t('event.menu.sponsors.title')"
              @btnAdd="
                updateFormCategory = null;
                addCategoryModal = true;
              "
              @btnRefresh="getData()"
              :buttonAdd="true"
              :buttonRefresh="true"
              :loading="loading"
            />
          </div>
          <div class="card-footer"></div>
        </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="addModal" :title="updateForm ? $t('contentManagement.sponsors.editSponsor') : $t('contentManagement.sponsors.addSponsor')" class="large" center modal-append-to-body destroy-on-close>
      <SponsorAddUpdate @deleteMe="deleteItem" @closeDialog="addModal = false" :id="updateForm" v-if="addModal" :categoryId="currentCategory" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="addCategoryModal" :title="updateFormCategory ? $t('contentManagement.sponsors.editCategory') : $t('contentManagement.sponsors.addCategory')" class="large" center modal-append-to-body destroy-on-close>
      <SponsorCategoryAddUpdate @deleteMeCategory="deleteItemCategory" @closeDialog="addCategoryModal = false" v-if="addCategoryModal" :id="updateFormCategory" />
    </el-dialog>
  </div>
</template>

<script>
import SponsorCategoryAddUpdate from "../../components/SponsorCategoryAddUpdate";
import SponsorAddUpdate from "../../components/SponsorAddUpdate";
import ExcelImport from "../../components/ExcelImport";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import draggable from "vuedraggable";
import $ from "jquery";
import _ from "lodash";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.sponsors")
    };
  },
  components: {
    SponsorAddUpdate,
    ExcelImport,
    PageCountInfo,
    draggable,
    SponsorCategoryAddUpdate
  },
  name: "AreaMaps",
  data() {
    return {
      loading: false,
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "areamaps",
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      list2: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      drag: false,
      currentCategory: null,
      axios,
      addModal: false,
      addCategoryModal: false,
      updateFormCategory: null,
      currDate: new Date().getTime(),
      widgetUrl: null
    };
  },
  methods: {
    async itemUpdated() {
      await this.$store.dispatch("getSponsors");
    },
    async itemAdded() {
      await this.$store.dispatch("getSponsors");
    },
    handleSizeChange(take) {
      this.$store.commit("setAreaMapTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setAreaMapPage", page);
    },
    async deleteItem(id) {
      this.loading = "loadingList";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("deleteSponsor", id);
        await this.$store.dispatch("getSponsors");
        this.currDate = new Date().getTime();
        this.loading = false;
      }, 5);
    },
    async deleteItemCategory(id) {
      var res = await this.$store.dispatch("deleteSponsorCategory", {
        context: this,
        id
      });
      var index = this.categories.findIndex(k => k.id == id);
      this.categories.splice(index, 1);
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleAreaMap", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedAreaMaps", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
    async saveSorting() {
      this.loading = "loadingList";
      await axios.post("sponsor/updatesorting", { items: this.categories }).then(res => {
        console.log(res.data);
      });
      setTimeout(() => {
        this.loading = false;
      }, "500");
    },
    async getData() {
      this.loading = "loadingList";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getSponsors");

        this.loading = false;
      }, 500);
    }
  },
  async created() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getEvent");
      await this.$store.dispatch("getSponsors");
      this.widgetUrl = "https://cdn.holacon.com/widgets/event-sponsors.html?eventID=" + this.$store.state.event.event.id + "&applicationID=" + this.$store.state.event.event.applicationID;
      this.loading = false;
    }, 500);
  },
  computed: {
    categories() {
      return this.$store.state.sponsors.categories;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    skip() {
      return (this.$store.state.sponsors.filter.page - 1) * this.$store.state.sponsors.filter.take;
    },
    take() {
      return this.skip + this.$store.state.sponsors.items.length;
    }
  },
  watch: {
    "$store.state.sponsors.filter.searchTerm": function() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.getData();
      }, 500);
    },
    drag: function(newVal) {
      if (newVal == false) {
        this.saveSorting();
      }
    }
  }
};
</script>
<style lang="less" scoped>
#sponsors-page {
  #draggable {
    margin: 10px 0px;
    min-width: 100%;
    span {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      min-height: 100px;
      width: 100%;
      min-width: 100%;
    }
  }
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: rgba(115, 204, 204, 0.1);
  }
  .sponsor-category-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    .sponsor-category {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      background-color: #f1f1f1;
      border-radius: 8px;
      padding: 4px 140px;
      position: relative;
      &.passive {
        background-color: #fff2f2 !important;
        .category-title {
          color: #505763;
        }
      }
      .category-title {
        font-size: 16px;
        color: #03658c;
        font-weight: 600;
        line-height: normal;
        text-align: center;
        // padding: 5px 10px;
        // border-radius: 8px;
        // background-color: rgba(255, 255, 255, 0.8);
        margin-top: 6px;
      }
      .sponsor-category-slider {
        width: 100%;
      }
      .sponsor-category-drag {
        margin: 10px 10px;
        position: absolute;
        left: 20px;
        i {
          box-sizing: border-box;
          font-size: 20px;
          color: #505763;
          cursor: grab;
        }
      }
      .sponsor-category-actions {
        position: absolute;
        right: 20px;
      }
    }
    .add-sponsor {
      margin: 6px;
      align-items: center;
      justify-content: center;
      background-size: 90%;
      border: 0.5px solid #f1f3f6;
      background-repeat: no-repeat;
      border-radius: 4px;
      padding: 5px;
      .add-sponsor-container {
        .add-sponsor-wrapper {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          span {
            font-weight: 600;
            color: #505763;
            font-size: 13px;
            text-align: center;
          }
        }
      }
    }
    .sponsor-item {
      margin: 6px;
      align-items: center;
      justify-content: center;
      background-size: 90%;
      border: 0.5px solid #f1f3f6;
      background-repeat: no-repeat;
      border-radius: 4px;
      padding: 5px;
      padding-bottom: 0px;
      &.img-passive-item {
        background-color: #fff2f2 !important;
      }
      .sponsor-item-img {
        cursor: pointer;
        &.img-passive {
          filter: grayscale(1);
        }
      }
    }
  }
  .add-category {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #f1f1f1;
    border-radius: 8px;
    padding: 4px 140px;
    margin-bottom: 8px;
    position: relative;
    cursor: pointer;
    span {
      font-size: 16px;
      color: #292f3b;
      font-weight: 600;
      line-height: normal;
      text-align: center;
      padding: 10px 10px;
      border-radius: 8px;
      i {
        margin-right: 6px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Sponsors.vue